<template>
  <div class="kk-mybusiness">
    <div class="kk-mybusiness-toolbar">
      <p class="kk-mybusiness-toolbar-title">{{ $t("mybusiness.title") }}</p>
    </div>
    <custom-accordion :is-open="isOpen" @clicked="clicked">
      <template #titleSlot>
        <div class="kk-mybusiness-card__header">
          <span>{{ $t("mybusiness.subscription.title") }}</span>
        </div>
        <custom-icon :class-name="`${isOpen ? icons.ChevronUp : icons.ChevronDown}`" />
      </template>
      <subs-quota @close-popup="$emit('close-popup')" />
    </custom-accordion>
  </div>
</template>

<script>
import SubsQuota from "./SubsQuota.vue";
import CustomAccordion from "../commons/CustomAccordion.vue";
import CustomIcon from "../commons/CustomIcon.vue";
import { icons } from "../../utils/icons";
export default {
  components: {
    SubsQuota,
    CustomAccordion,
    CustomIcon,
  },
  emits: ["close-popup"],
  data() {
    return {
      isOpen: true,
      icons: icons,
    };
  },
  methods: {
    clicked() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/styles/variables";

.kk-setting {
  min-width: 40rem;
  padding: 0.5rem 2rem 2rem;
}

.kk-mybusiness {
  &-toolbar {
    background-color: @kk-primary-btn-bg-color;
    color: @kk-color-white;
    padding: 1rem;
    font-weight: 400;
    &-title {
      font-size: 18px;
      font-weight: bold;
    }
  }
  &-card__header {
    padding: 1rem;
    span {
      font-weight: 600;
    }
  }
}
</style>
